import React from 'react';
import './HeroSection.css';
import doctorImage from '../../../pic/doctor-image.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function HeroSection() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleRegisterClick = () => {
        navigate('/login');
    };

    return (
        <section className="hero-section">
            <div className="hero-content">
                <h1 style={{ fontFamily: 'Josefin Sans, sans-serif' }}>{t('hero.title')}</h1>
                <p style={{ fontFamily: 'Josefin Sans, sans-serif' }}>{t('hero.subtitle')}</p>
                <button
                    style={{ fontFamily: 'Josefin Sans, sans-serif' }}
                    className="register-button"
                    onClick={handleRegisterClick}
                >
                    {t('hero.registerNow')}
                </button>
            </div>
            <div className="hero-image">
                <img src={doctorImage} alt="Doctor" />
            </div>
        </section>
    );
}

export default HeroSection;
